import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import Home from "@/components/Home";
import List from "@/components/List";
import ForgetPwd from "@/components/ForgetPwd";
import MobileLogin from "@/components/mobile/Login";
import MobileForgetPwd from "@/components/mobile/ForgetPwd";
import MobileHome from "@/components/mobile/Home";
import MobileOA from "@/components/mobile/OA";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    // {
    //   path: '/',
    //   redirect: '/login'
    // },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/forgetPwd",
      name: "ForgetPwd",
      component: ForgetPwd
    },
    {
      path: "/mobile_login",
      name: "MobileLogin",
      component: MobileLogin
    },
    {
      path: "/mobile_forgetPwd",
      name: "MobileForgetPwd",
      component: MobileForgetPwd
    },
    {
      path: "/home",
      name: "Home",
      component: Home
    },
    {
      path: "/mobile_home",
      name: "MobileHome",
      component: MobileHome
    },
    {
      path: "/mobile_oa",
      name: "MobileOA",
      component: MobileOA
    },
    {
      path: "/list",
      name: "List",
      component: List
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js